// extracted by mini-css-extract-plugin
export default {"wrapper":"regiv","item":"HiErj","isSelected":"RrUO5"};